import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let state
state = {
	visitedViews : [],
	activeView : '',
	userToken : '',
	message : '',
	channelList : [
		{
			value: '',
			label: '全部'
		},
		{
			value: '官网',
			label: '官网'
		}, {
			value: '企业手机银行',
			label: '企业手机银行'
		}, {
			value: '个人手机银行',
			label: '个人手机银行'
		},
		{
			value: '企业网银',
			label: '企业网银'
		}, {
			value: '个人网银',
			label: '个人网银'
		}, {
			value: '微信银行',
			label: '微信银行'
		},
		{
			value: '合作商户',
			label: '合作商户'
		}
	]
}

const store = new Vuex.Store({
	state,
	mutations: {
	},
	actions: {
	}
})
export default store
